module.exports = __webpack_public_path__ + "static/media/i_featured_uri.92376927.svg";